"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = exports.getToken = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _globals = require("@insided/shared/utils/globals");

var getToken = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(csrfToken) {
    var prefix, response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            prefix = (0, _globals.getSubfolderPrefix)();
            _context.next = 3;
            return _axios.default.get("".concat(prefix, "/site/_tokens?name=conversationMessage&yip_csrf_token=").concat(csrfToken));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response.data._token);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getToken = getToken;

var sendMessage = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(conversationId, params) {
    var response;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post("/inbox/conversation?with=".concat(conversationId), params.toString(), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              },
              withCredentials: true
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data.errors);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function sendMessage(_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.sendMessage = sendMessage;